import { AvailabilityStatusDTO } from "../../../../models/recruiting/candidate/availability-statuses/availability-status-dto";
import { AvailabilityStatusSTO } from "../../../../models/recruiting/candidate/availability-statuses/availability-status-sto";
import { BaseApiService } from "../../../base/base-api.service";

export class AvailabilityStatusApiService extends BaseApiService<AvailabilityStatusDTO, AvailabilityStatusSTO> {
  constructor() {
    super({
      servicePath: "/AvailabilityStatuses",
      loadItemsPath: "/GetAvailabilityStatuses",
    });
  }
}
